import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgLargeProfile = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 68 68", size: size }, props),
        React.createElement("path", { fill: "currentColor", d: "M34 34a8.5 8.5 0 100-17 8.5 8.5 0 000 17z" }),
        React.createElement("path", { fill: "currentColor", d: "M34 12.8c11.7 0 21.3 9.5 21.3 21.3 0 11.7-9.5 21.3-21.3 21.3S12.8 45.7 12.8 34 22.3 12.8 34 12.8zm0-4.3C19.9 8.5 8.5 19.9 8.5 34S19.9 59.5 34 59.5 59.5 48.1 59.5 34 48.1 8.5 34 8.5z" }),
        React.createElement("path", { fill: "currentColor", d: "M34 38.3c-7.9 0-14.6 5.4-16.5 12.8L34 58.3 50.5 51c-1.9-7.3-8.6-12.7-16.5-12.7z" })));
};
export default SvgLargeProfile;
//# sourceMappingURL=LargeProfile.js.map